import { CASHDESK_FN_BALANCEITEM_PARAMS } from "../@models/cashdeskfnparams.model";
import { RxCluTickDuplicataDocumentType } from "../@schemas/clu_tickduplicata.schema";
import { RxFArtEnumRefDocument, RxFArticleDocument, RxFClientDocument, RxFConditionDocument, RxFNomenclatDocument, RxFTarifQteDocument } from "../@services/m-cashdesk-core-rxdb";
import { CASHDESK_VX_CSTMELEMENT_ITEM } from "./cashdesk-view-vx/cashdesk-view-vx.model";

export class CluMediaOptions { 
    LAYOUT_MOBILE_VIEW : boolean = false; 
    LAYOUT_MOBILE_VIEW_L : boolean = false;
    LAYOUT_BELOWMONITOR : boolean = false; 
    LAYOUT_BELOWMONITOR_L : boolean = false; 
    LAYOUT_BELOWMONITOR_M : boolean = false; 
    LAYOUT_BELOWMONITOR_L1100 : boolean = false; 
    D_MODE : 'main' | 'cart' = 'main';
}

export class CluSearchResult {
    ARTICLES : RxFArticleDocument[];
    CLIENTS : RxFClientDocument[];
    ARTENUMREFS : RxFArtEnumRefDocument[];
    CONDITIONS : RxFConditionDocument[];
}

export class CluSearchItemPickedResult {
    TYPE : 'ARTICLE' | 'CLIENT';
    VALUE_ARTICLE : RxFArticleDocument | undefined;
    VALUE_CLIENT : RxFClientDocument | undefined;
}

export class CluArtGammesPickedResult {
    AG_NO1 : number = 0;
    AG_NO1LIB : string = '';
    AG_NO2 : number = 0;
    AG_NO2LIB : string = '';
}

export class CluConditionPickedResult {
    NO_CONDITION : boolean;
    VALUE_CONDITION : RxFConditionDocument | undefined;
    TC_PRIX_U : number;
}

export class CluArtFamComptaItem {
    N_CATCOMPTA? : number;
    DL_CODETAXE1? : string;
    DL_LIBTAXE1? : string;
    DL_TAXE1? : number;
    DL_TYPETAXE1? : number;
    DL_TYPETAUX1? : number;
    DL_CODETAXE2? : string;
    DL_LIBTAXE2? : string;
    DL_TAXE2? : number;
    DL_TYPETAXE2? : number;
    DL_TYPETAUX2? : number;
    DL_CODETAXE3? : string;
    DL_LIBTAXE3? : string;
    DL_TAXE3? : number;
    DL_TYPETAXE3? : number;
    DL_TYPETAUX3? : number;
}

export class CluNomenclatureItem {
    NOMENCLATURE : RxFNomenclatDocument;
    PARENT_ARTICLE : RxFArticleDocument;
    REF_ARTICLE : RxFArticleDocument;
    REF_ARTICLE_ARTGAMME : CluArtGammesPickedResult | undefined;
}

export class CluLotSerieItemPickedResult {
    CANCELED : boolean;
    PICKED_ITEMS : CluLotSeriePickedItemResult[] = [];
}

export class CluLotSeriePickedItemResult {
    DE_NO : number = 0;
    DE_INTITULE : string = '';
    LS_NOSERIE : string = '';
    LS_COMPLEMENT : string = '';
    LS_PEREMPTION : Date | undefined;
    LS_FABRICATION : Date | undefined;
    LS_QTE : number = 0;
}

export class CluCarteCadeauxItemPickedResult {
    CANCELED : boolean;

    DL_GF_CARTE_NUM : string = '';
    DL_GF_CARTE_DESIGNATION : string = '';
    DL_GF_C_TOTAL_TTC_INIT : number = 0;
    DL_GF_DATE_DEBUT : Date;
    DL_GF_DATE_EXP : Date;
}

export class CluFunctionItemPickedResult {
    FN_ITEM : any;
}

export class CluVxValueChangedResult {
    VALUE_FIELD : string;
    VALUE : string;
    CSTM_ELEMENT : CASHDESK_VX_CSTMELEMENT_ITEM;
}

export class CluDiscountResult {
    DL_REMISE_LIB : string;
    DL_REMISE01REM_VALEUR : number = 0;
    DL_REMISE01REM_TYPE : number = 0;
    DL_REMISE02REM_VALEUR : number = 0;
    DL_REMISE02REM_TYPE : number = 0;
    DL_REMISE03REM_VALEUR : number = 0;
    DL_REMISE03REM_TYPE : number = 0;
}

export class CluDefaultRemisesResult {
    SPECREM_FOUND : boolean = false;
    
    SPECREM_ARTICLE_FOUND : boolean = false;
    TYPEREM : number = 0;
    QTEMONT : number = 0;
    REM : number = 0;
    TARIFQTE_ITEMS : RxFTarifQteDocument[] = [];

    SPECREM_CLIENT_FOUND : boolean = false;
    REM_CLIENT : number = 0;
    REM_CONFLICT_MODE : number = 0;
}

export class CluPrintResult {
    MODE : 'canceled' | 'print' | 'print_n' | 'email' | 'none' = 'canceled';
    PRINTED_N : number = 0;
    EMAIL_1 ?: string = '';
    EMAIL_2 ?: string = '';
    EMAIL_3 ?: string = '';
    DUPLICATA?: boolean;
    DUPLICATA_ITEM? : RxCluTickDuplicataDocumentType | undefined = undefined;
    REMAINING_PRINTS?: number;
}

export class CLU_RECOMPENSE_TYPE {
    public static R_REMISE_GLOBALE : number = 1;
    public static R_REMISE_LIGNE_P : number = 2;
    public static R_REMISE_GLOBALE_MT : number = 3;
    public static R_REMISE_LIGNE_MT : number = 4;
    public static R_AR_GRATUITE : number = 5;
    public static R_AR_TARIFPREFERENTIEL : number = 6;
}

export class CluLoyaltyCardRecompenseParams {
    LC_REC_PTS_NB : number = 0;
    LC_PG_GID : string;
    LC_REC_GID : string;
    LC_REC_TYPE : number = 0;
}

export class CLU_FUNCTION_CODES {
    public static FN_CASHDESK_CLOSING_X : string = 'FN_CASHDESK_CLOSING_X';
    public static FN_CASHDESK_CLOSING_Z : string = 'FN_CASHDESK_CLOSING_Z';
    public static FN_CASHDESK_CASHOPS : string = 'FN_CASHDESK_CASHOPS';
    public static FN_CASHDESK_OPENCASHDESK : string = 'FN_CASHDESK_OPENCASHDESK';
    public static FN_SEARCH_TICKET : string = 'FN_SEARCH_TICKET';
    public static FN_SEARCH_CLIENT : string = 'FN_SEARCH_CLIENT';
    public static FN_SEARCH_ARTICLE : string = 'FN_SEARCH_ARTICLE';
    public static FN_DELETE_TICKLIGNES : string = 'FN_DELETE_TICKLIGNES';
    public static FN_REORDER_TICKLIGNES : string = 'FN_REORDER_TICKLIGNES';
    public static FN_WEIGHITEM_TICKLIGNES : string = 'FN_WEIGHITEM_TICKLIGNES';
    public static FN_ADD_TICKET_SUBTOTAL : string = 'FN_ADD_TICKET_SUBTOTAL';
    public static FN_PAUSE_TICKET : string = 'FN_PAUSE_TICKET';
    public static FN_PAUSED_TICKETS : string = 'FN_PAUSED_TICKETS';
    public static FN_CANCEL_TICKET : string = 'FN_CANCEL_TICKET';
    public static FN_PRINT_TICKET : string = 'FN_PRINT_TICKET';
    public static FN_SEND_TICKET_EMAIL : string = 'FN_SEND_TICKET_EMAIL';
    public static FN_DISCOUNT_TICKLIGNE : string = 'FN_DISCOUNT_TICKLIGNE';
    public static FN_DISCOUNT_TICKLIGNE_ALL : string = 'FN_DISCOUNT_TICKLIGNE_ALL';
    public static FN_DISCOUNT_TICKGLOBAL_P_HT : string = 'FN_DISCOUNT_TICKGLOBAL_P_HT';
    public static FN_DISCOUNT_TICKGLOBAL_P : string = 'FN_DISCOUNT_TICKGLOBAL_P';
    public static FN_DISCOUNT_TICKGLOBAL_V : string = 'FN_DISCOUNT_TICKGLOBAL_V';
    public static FN_DELETE_DISCOUNT : string = 'FN_DELETE_DISCOUNT';
    public static FN_CORRECT_REGLEMENT : string = 'FN_CORRECT_REGLEMENT';
    public static FN_HANDLE_CARTEFIDELITE : string = 'FN_HANDLE_CARTEFIDELITE';
    public static FN_LINK_CARTEFIDELITE : string = 'FN_LINK_CARTEFIDELITE';
    public static FN_GET_CARTEFIDELITE : string = 'FN_GET_CARTEFIDELITE';
    public static FN_GENERATE_RETURN : string = 'FN_GENERATE_RETURN';
    public static FN_GET_CARTECADEAU : string = 'FN_GET_CARTECADEAU';
    public static FN_ADD_CARTECADEAU : string = 'FN_ADD_CARTECADEAU';
    public static FN_DUPLICATA_GEN : string = 'FN_DUPLICATA_GEN';
    public static FN_REMDOCS_ALL : string = 'FN_REMDOCS_ALL';
}

export class CluBilanTaxeItem {
    DL_CODETAXE : string = '';
    DL_TAXELIB : string = '';
    T_BASE : string = '';
    T_TAUX : number;
    T_TYPETAUX : number = 0;
    T_MONTANT : number;
}

export class CluCustomInputItem {
    FIELD_ORIG : 'DL' | 'CL_DL';
    FIELD : string;
    FIELD_LIB : string;
    TYPE : number;
    TYPE_LIB : string;
    MAX_LENGTH : number = 0;
}

export class CluWeighItemResult {
    B_ITEM : CASHDESK_FN_BALANCEITEM_PARAMS;
    B_RAYON_CODEBARRE : string = '';
    B_RAYON_CODEBARRE_EXTRACT_REFERENCE : string = '';
    B_RAYON_CODEBARRE_EXTRACT_POIDS : number = 0;
    B_RAYON_CODEBARRE_EXTRACT_PRIX : number = 0;
    B_RAYON_MATCHES : any[] = [];
    B_RAYON_MATCH : RxFArticleDocument | undefined;
    
    B_CAISSE_MATCH : RxFArticleDocument | undefined;
    B_CAISSE_RESULTAT_POIDS : number = 0;
}

// #region Panel Views
export class CluPanelParams {
    ID : number;
    SITEGID? : string;
    DATE_CREATION? : Date;
    PANELTYPE : number;
    DENOMINATION : string = '';
    PANELPARAMS : string = '';
}

export class CluPanelParams_FAMILLES {
    horizontalScroll : boolean = false; 
    CATEGORY_SORTARRAY : string[] = [];
    CATEGORY_SORTMAP : {[key: string]: string[]} = {};  
    SUBCATEGORY_SORTMAP : {[key: string]: string[]} = {};
    SUBCATEGORY_SORTMAP_OBJ : any;  
}

export class CluPanelParams_CATEGORIES {
    horizontalScroll : boolean = false; 
    CATEGORY_ITEMS : CluPanelParams_CATEGORIES_CATITEM[] = [];

    CATEGORY_SORTARRAY : string[] = [];
    CATEGORY_SORTMAP : {[key: string]: string[]} = {};  
    SUBCATEGORY_SORTMAP : {[key: string]: string[]} = {};
}

export class CluPanelParams_CATEGORIES_CATITEM {
    CODE : string = '';
    DENOMINATION : string = '';
    SOUS_TITRE : string = '';
    ICON : string = '';
    COLOR : string = '';
    INDEX : number = -1;

    SOUSCATEGORIES_ITEMS : CluPanelParams_CATEGORIES_SUBCATITEM[] = [];
    AR_COUNT : number = 0;
}

export class CluPanelParams_CATEGORIES_SUBCATITEM {
    CODE : string = '';
    DENOMINATION : string = '';
    SOUS_TITRE : string = '';
    INDEX : number = -1;

    ARREF_ITEMS : string[] = [];
    ARREF_PITEMS : any[] = [];
}

export class CluPanelParams_CATALOGUES {
    horizontalScroll : boolean = false; 
}
// #endregion